import React from 'react';
import CharacterTile from '../CharacterTile/CharacterTile';
import { FilterTag } from 'types';

type Props = {
  items: Array<FilterTag>;
  selectedItems: Array<FilterTag>;
  onSelectItem: (itemId: number) => void;
};

function CharacterGrid(props: Props): React.ReactElement {
  function isItemSelected(item: any): boolean {
    return props.selectedItems.findIndex(tag => tag.id === item.id) !== -1;
  }

  function handleSelectItem(item: any) {
    return function () {
      props.onSelectItem(item);
    };
  }

  function renderItems(): Array<React.ReactElement> {
    return props.items.map(function (item: FilterTag, index: number) {
      return (
        <CharacterTile
          key={index}
          size={40}
          character={item}
          selected={isItemSelected(item)}
          onClick={handleSelectItem(item)}
        />
      );
    });
  }

  return (
    <div
      style={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '40px 40px 40px 40px 40px',
        gridGap: '10px 10px'
      }}
    >
      {renderItems()}
    </div>
  );
}

export default CharacterGrid;
